import { Injectable, isDevMode } from '@angular/core';
import { BaseApiService } from '../base.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

interface APIPayload {
  first_name: string;
  last_name: string;
  location: string;
  birth_year: number | null;
  gender: string;
  ethnicity: string[];
  school_grade: string;
  graduation_year: string;
  school_name: string;
  graduation_major: string;
  is_working: boolean;
  job_type?: string | null;
  future_location: string;
  desired_location_google_place_id?: string | null;
  desired_location_google_administrative_area_level_2?: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class UserBiqService extends BaseApiService {
  constructor(http: HttpClient) {
    const apiBaseUrl = isDevMode() ? '/users-api' : environment.usersApiUrl;
    super(http, apiBaseUrl);
  }

  saveUserInfo(data: APIPayload): Observable<any> {
    return this.post<any>('background-info', data);
  }
}
